import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import logo from '../assets/dupont-logo.png'; //path to logo file
import logo2 from '../assets/Nomex_rgb.png'; //path to logo file
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'white',
  [theme.breakpoints.down('sm')]: {
    height: '60px',
  },
  [theme.breakpoints.up('sm')]: {
    height: '70px',
  },
  [theme.breakpoints.between('xs', 'md')]: {
    height: '65px', // Specific adjustment for resolution around 655px width
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  justifyContent: 'space-between',
  padding: '5px',
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
}));

const StyledImg = styled('img')(({ theme }) => ({
  height: '20px',
  [theme.breakpoints.down('xs')]: {
    height: '20px',
  },
  [theme.breakpoints.up('sm')]: {
    height: '30px',
  },
  [theme.breakpoints.between('xs', 'md')]: {
    height: '20px', // Specific adjustment for 655px resolution
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontFamily: 'DiodrumSemibold',
  flexGrow: 1,
  fontSize: '130%',
  textAlign: 'center',
  margin: '0 10%',
  [theme.breakpoints.down('sm')]: {
    fontSize: '90%',
    margin: '0',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '120%',
  },
  [theme.breakpoints.between('xs', 'md')]: {
    fontSize: '80%', // Specific adjustment for 655px resolution
  },
}));

const UserBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

const UserTypography = styled(Typography)(({ theme }) => ({
  color: 'black',
  textAlign: 'right',
  marginRight: '10px',
  fontFamily: 'DiodrumRegular',
  [theme.breakpoints.down('xs')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.between('xs', 'md')]: {
    fontSize: '11px', // Specific adjustment for 655px resolution
  },
}));

export default function ButtonAppBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLogged, setIsLogged] = React.useState(localStorage.getItem('jwt_token') ? true : false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  //get user details from local storage
  const userName = JSON.parse(localStorage.getItem('user'));

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('id_token');
    setIsLogged(false);
    window.location.href = process.env.REACT_APP_LOGOUT_ENDPOINT;
  };

  // Handle menu open
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogin = () => {
    window.location.href = '/';
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <StyledAppBar position="fixed">
        <StyledToolbar>
          <LogoContainer>
            <StyledImg src={logo} alt="Dupont Logo" />
            <StyledImg src={logo2} alt="Nomex Logo" style={{ marginLeft: '10px' }} />
          </LogoContainer>

          <TitleTypography>
            Nomex® Comfort <span style={{ color: '#58B947' }}>with EcoForce™ Technology</span>
          </TitleTypography>

          {isLogged ? (
            <UserBox>
              <UserTypography>
                {userName ? `Welcome, ${userName.First_Name} ${userName.Last_Name}` : ''}
              </UserTypography>
              <IconButton color="inherit" size="large" onClick={handleMenuOpen}>
                <AccountCircleIcon fontSize="large" sx={{ color: '#58B947' }} />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </UserBox>
          ) : (
            <UserBox>
              <IconButton color="default" size="medium" onClick={handleMenuOpen}>
                <AccountCircleOutlinedIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleLogin}>Login</MenuItem>
              </Menu>
            </UserBox>
          )}
        </StyledToolbar>
      </StyledAppBar>
    </Box>
  );
}
